import { compact, reduce } from 'lodash';
import { HAS_WINDOW } from '../feature-detection';

/**
 * reducePaths
 *
 * Joins paths together and short curcuits for an absolute path
 *
 * @param {string} base path to join additional paths to
 * @param {string} path path to join to base
 */
var reducePaths = function reducePaths(base, path) {
  if (path && path.match && path.match(/^\//)) {
    return path;
  }
  return compact([base && base.replace && base.replace(/\/$/, ''), path]).join('/');
};

/**
 * join parts of a path together, respects absolute paths
 *
 * @param  {...string} parts items in the path to join together
 */
export var join = function join() {
  for (var _len = arguments.length, parts = Array(_len), _key = 0; _key < _len; _key++) {
    parts[_key] = arguments[_key];
  }

  return reduce(parts, reducePaths, '');
};

/**
 * getUrlPath
 *
 * Get url pathname
 *
 * @return string url pathname
 */
export var getUrlPath = function getUrlPath() {
  return HAS_WINDOW ? window.location.pathname : null;
};